// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `@media (max-width: 1024px) {
  .col-sm-1 {
    width: 8.33%;
  }
  .col-sm-2 {
    width: 16.66%;
  }
  .col-sm-3 {
    width: 25%;
  }
  .col-sm-4 {
    width: 33.33%;
  }
  .col-sm-5 {
    width: 41.66%;
  }
  .col-sm-6 {
    width: 50%;
  }
  .col-sm-7 {
    width: 58.33%;
  }
  .col-sm-8 {
    width: 66.66%;
  }
  .col-sm-9 {
    width: 75%;
  }
  .col-sm-10 {
    width: 83.33%;
  }
  .col-sm-11 {
    width: 91.66%;
  }
  .col-sm-12 {
    width: 100%;
  }
  .col-sm-offset-1 {
    margin-left: 8.33%;
  }
  .col-sm-offset-2 {
    margin-left: 16.66%;
  }
  .col-sm-offset-3 {
    margin-left: 25%;
  }
  .col-sm-offset-4 {
    margin-left: 33.33%;
  }
  .col-sm-offset-5 {
    margin-left: 41.66%;
  }
  .col-sm-offset-6 {
    margin-left: 50%;
  }
  .col-sm-offset-7 {
    margin-left: 58.33%;
  }
  .col-sm-offset-8 {
    margin-left: 66.66%;
  }
  .col-sm-offset-9 {
    margin-left: 75%;
  }
  .col-sm-offset-10 {
    margin-left: 83.33%;
  }
  .col-sm-offset-11 {
    margin-left: 91.66%;
  }
  .col-sm-offset-12 {
    margin-left: 100%;
  }
}
@media (min-width: 1025px) {
  .col-md-1 {
    width: 8.33%;
  }
  .col-md-2 {
    width: 16.66%;
  }
  .col-md-3 {
    width: 25%;
  }
  .col-md-4 {
    width: 33.33%;
  }
  .col-md-5 {
    width: 41.66%;
  }
  .col-md-6 {
    width: 50%;
  }
  .col-md-7 {
    width: 58.33%;
  }
  .col-md-8 {
    width: 66.66%;
  }
  .col-md-9 {
    width: 75%;
  }
  .col-md-10 {
    width: 83.33%;
  }
  .col-md-11 {
    width: 91.66%;
  }
  .col-md-12 {
    width: 100%;
  }
  .col-md-offset-1 {
    margin-left: 8.33%;
  }
  .col-md-offset-2 {
    margin-left: 16.66%;
  }
  .col-md-offset-3 {
    margin-left: 25%;
  }
  .col-md-offset-4 {
    margin-left: 33.33%;
  }
  .col-md-offset-5 {
    margin-left: 41.66%;
  }
  .col-md-offset-6 {
    margin-left: 50%;
  }
  .col-md-offset-7 {
    margin-left: 58.33%;
  }
  .col-md-offset-8 {
    margin-left: 66.66%;
  }
  .col-md-offset-9 {
    margin-left: 75%;
  }
  .col-md-offset-10 {
    margin-left: 83.33%;
  }
  .col-md-offset-11 {
    margin-left: 91.66%;
  }
  .col-md-offset-12 {
    margin-left: 100%;
  }
}
.tab-section [class*=icon-accordion-] {
  display: none !important;
}
@media (max-width: 1024px) {
  .tab-section [class*=icon-accordion-] {
    display: inline-block !important;
    float: right;
    margin-top: -10px;
    position: absolute;
    right: 10px;
    top: 50%;
  }
}

.tab-nav {
  border-bottom: 1px solid #d2d2d2;
}
.tab-nav app-tab {
  float: left;
}
@media (max-width: 1024px) {
  .tab-nav app-tab {
    float: none;
  }
  .tab-nav app-tab .list > a {
    border-left: 0 !important;
    border-right: 0 !important;
    border-top: 0 !important;
    padding: 25px 15px !important;
    position: relative;
  }
  .tab-nav app-tab .list > a:focus {
    outline: 0;
  }
  .tab-nav app-tab:first-child .list > a {
    border-top: 1px solid #d2d2d2 !important;
  }
  .tab-nav app-tab:last-child + .tab-content {
    border-bottom: 0;
  }
  .tab-nav app-tab.active + .tab-content {
    border-bottom: 1px solid #d2d2d2;
  }
  .tab-nav app-tab.active:last-child .list > a {
    border-bottom: 0;
  }
}
.tab-nav app-tab .list.active > a {
  border-bottom: 1px solid white;
  border-top: 5px solid hsl(204.9, 94.4%, 35.1%);
  color: #191919;
  padding-top: 25px;
}
.tab-nav app-tab .list a {
  background: white;
  border-bottom: 1px solid #d2d2d2;
  border-right: 1px solid #d2d2d2;
  bottom: -1px;
  color: hsl(204.9, 94.4%, 35.1%);
  display: block;
  font-size: 20px;
  height: 70px;
  outline: none;
  padding: 30px 20px 25px;
  position: relative;
}
.tab-nav app-tab .list a:focus {
  outline: thin dotted #191919;
  outline-offset: 0;
}
.tab-nav app-tab:first-of-type .list a {
  border-left: 1px solid transparent;
}
.tab-nav app-tab:first-of-type .list.active a {
  border-left: 1px solid #d2d2d2;
}
.tab-nav app-tab:last-of-type .list a {
  border-right: 1px solid transparent;
}
.tab-nav app-tab:last-of-type .list.active a {
  border-right: 1px solid #d2d2d2;
}

.tab-content {
  left: 0;
  padding: 15px;
  position: absolute;
  top: 70px;
  width: 100%;
}
@media (max-width: 1024px) {
  .tab-content {
    border-bottom: 1px solid #d2d2d2;
    padding-top: 0;
    position: relative;
    top: 1px;
  }
  .tab-content h2 {
    margin-bottom: 0 !important;
    margin-top: 20px !important;
  }
  .tab-content p {
    margin-bottom: 5px !important;
  }
}
.tab-content h2 {
  font-size: 1.9rem;
  font-weight: bold;
  margin-bottom: 20px;
  margin-top: 40px;
}
.tab-content ul {
  margin: 0 0 20px 20px;
}
.tab-content ul li {
  line-height: 20px;
  margin-top: 12px;
  padding-left: 15px;
  position: relative;
  text-align: left;
}
.tab-content ul li:first-child {
  margin-top: 5px;
}
.tab-content ul li::after {
  background-color: #333333;
  border: 2px solid #333333;
  border-radius: 100%;
  content: "";
  display: block;
  height: 1px;
  left: 0;
  position: absolute;
  top: 8px;
  width: 1px;
}
.tab-content h4 {
  font-family: "Omnes-ATT-W02-Medium";
  font-size: 1.6rem;
  margin: 10px 0 5px;
}
.tab-content p {
  margin-bottom: 15px;
}
.tab-content .price-box {
  border-radius: 8px;
  border-radius: 8px;
  border-radius: 8px;
  border-radius: 8px;
  border-radius: 8px;
  border: 1px solid #d2d2d2;
  margin: 10px -15px 20px;
  padding: 15px;
}
.tab-content .price-box .price {
  display: inline-block;
  font-size: 3rem;
  margin-bottom: 10px;
  margin-right: 10px;
}
.tab-content .price-box p {
  margin-bottom: 0;
}

.gray-box {
  background: hsl(0, 0%, 95%);
  margin-top: 20px;
  padding: 15px;
}`, "",{"version":3,"sources":["webpack://./src/lib/ng2-sapmp/src/assets/style/mixinfunction.scss","webpack://./src/lib/ng2-sapmp/src/assets/style/variables.scss","webpack://./src/lib/ng2-sapmp/src/ui-components/tab/tabs.component.scss"],"names":[],"mappings":"AAwBI;EA4BA;IACE,YClDE;ECAN;EFiDE;IACE,aClDE;ECGN;EF8CE;IACE,UClDE;ECMN;EF2CE;IACE,aClDE;ECSN;EFwCE;IACE,aClDE;ECYN;EFqCE;IACE,UClDE;ECeN;EFkCE;IACE,aClDE;ECkBN;EF+BE;IACE,aClDE;ECqBN;EF4BE;IACE,UClDE;ECwBN;EFyBE;IACE,aClDE;EC2BN;EFsBE;IACE,aClDE;EC8BN;EFmBE;IACE,WClDE;ECiCN;EFqBE;IACE,kBCvDE;ECoCN;EFkBE;IACE,mBCvDE;ECuCN;EFeE;IACE,gBCvDE;EC0CN;EFYE;IACE,mBCvDE;EC6CN;EFSE;IACE,mBCvDE;ECgDN;EFME;IACE,gBCvDE;ECmDN;EFGE;IACE,mBCvDE;ECsDN;EFAE;IACE,mBCvDE;ECyDN;EFHE;IACE,gBCvDE;EC4DN;EFNE;IACE,mBCvDE;EC+DN;EFTE;IACE,mBCvDE;ECkEN;EFZE;IACE,iBCvDE;ECqEN;AACF;AF7CI;EAoCA;IACE,YC9DE;EC0EN;EFbE;IACE,aC9DE;EC6EN;EFhBE;IACE,UC9DE;ECgFN;EFnBE;IACE,aC9DE;ECmFN;EFtBE;IACE,aC9DE;ECsFN;EFzBE;IACE,UC9DE;ECyFN;EF5BE;IACE,aC9DE;EC4FN;EF/BE;IACE,aC9DE;EC+FN;EFlCE;IACE,UC9DE;ECkGN;EFrCE;IACE,aC9DE;ECqGN;EFxCE;IACE,aC9DE;ECwGN;EF3CE;IACE,WC9DE;EC2GN;EFzCE;IACE,kBCnEE;EC8GN;EF5CE;IACE,mBCnEE;ECiHN;EF/CE;IACE,gBCnEE;ECoHN;EFlDE;IACE,mBCnEE;ECuHN;EFrDE;IACE,mBCnEE;EC0HN;EFxDE;IACE,gBCnEE;EC6HN;EF3DE;IACE,mBCnEE;ECgIN;EF9DE;IACE,mBCnEE;ECmIN;EFjEE;IACE,gBCnEE;ECsIN;EFpEE;IACE,mBCnEE;ECyIN;EFvEE;IACE,mBCnEE;EC4IN;EF1EE;IACE,iBCnEE;EC+IN;AACF;AAhJE;EASE,wBAAA;AA0IJ;AF9HI;EErBF;IAEI,gCAAA;IACA,YAAA;IACA,iBAAA;IACA,kBAAA;IACA,WAAA;IACA,QAAA;EAqJJ;AACF;;AAhJA;EACE,gCAAA;AAmJF;AAjJE;EAyCE,WAAA;AA2GJ;AF/II;EELF;IAEI,WAAA;EAsJJ;EApJI;IACE,yBAAA;IACA,0BAAA;IACA,wBAAA;IACA,6BAAA;IACA,kBAAA;EAsJN;EApJM;IACE,UAAA;EAsJR;EAjJM;IACE,wCAAA;EAmJR;EA9IM;IACE,gBAAA;EAgJR;EA3IM;IACE,gCAAA;EA6IR;EAxIQ;IACE,gBAAA;EA0IV;AACF;AAnIM;EACE,8BAAA;EACA,8CAAA;EACA,cAAA;EACA,iBAAA;AAqIR;AAlIM;EACE,iBAAA;EACA,gCAAA;EACA,+BAAA;EAEA,YAAA;EACA,+BAAA;EACA,cAAA;EACA,eAAA;EACA,YAAA;EACA,aAAA;EACA,uBAAA;EACA,kBAAA;AAmIR;AAjIQ;EACE,4BAAA;EACA,iBAAA;AAmIV;AA5HQ;EACE,kCAAA;AA8HV;AA1HU;EACE,8BAAA;AA4HZ;AApHQ;EACE,mCAAA;AAsHV;AAlHU;EACE,+BAAA;AAoHZ;;AA5GA;EAgBE,OAAA;EACA,aAAA;EACA,kBAAA;EACA,SAAA;EACA,WAAA;AAgGF;AFrNI;EEiGJ;IAEI,gCAAA;IACA,cAAA;IACA,kBAAA;IACA,QAAA;EAsHF;EApHE;IACE,2BAAA;IACA,2BAAA;EAsHJ;EAnHE;IACE,6BAAA;EAqHJ;AACF;AA7GE;EACE,iBAAA;EACA,iBAAA;EACA,mBAAA;EACA,gBAAA;AA+GJ;AA5GE;EACE,qBAAA;AA8GJ;AA5GI;EACE,iBAAA;EACA,gBAAA;EACA,kBAAA;EACA,kBAAA;EACA,gBAAA;AA8GN;AA5GM;EACE,eAAA;AA8GR;AA3GM;EACE,yBAAA;EACA,yBAAA;EACA,mBAAA;EACA,WAAA;EACA,cAAA;EACA,WAAA;EACA,OAAA;EACA,kBAAA;EACA,QAAA;EACA,UAAA;AA6GR;AAxGE;EACE,mCAAA;EACA,iBAAA;EACA,kBAAA;AA0GJ;AAvGE;EACE,mBAAA;AAyGJ;AAtGE;EFzJE,kBAAA;EAAA,kBAAA;EAAA,kBAAA;EAAA,kBAAA;EAAA,kBAAA;EEqKA,yBAAA;EACA,uBAAA;EACA,aAAA;AAkGJ;AAhGI;EACE,qBAAA;EACA,eAAA;EACA,mBAAA;EACA,kBAAA;AAkGN;AA/FI;EACE,gBAAA;AAiGN;;AA3FA;EACE,2BAAA;EACA,gBAAA;EACA,aAAA;AA8FF","sourcesContent":["@import 'variables';\n\n@function color($color-name, $color-variant: null) {\n  // color variant is optional\n  @if ($color-variant != null) {\n    // map inception\n    @return map-get(map-get($colors, $color-name), $color-variant);\n  }@else {\n    @return map-get($colors, $color-name);\n  }\n}\n// buttons building section\n\n$btns: (\n  default: color(default, base),\n  primary: color(primary, base),\n  secondary:  color(secondary, base),\n  inverse: color(inverse, light),\n  success: color(success, base),\n  danger:  color(danger, base)\n);\n\n@mixin respond-to($breakpoint) {\n  @if $breakpoint == 'small' {\n    @media (max-width: 1024px) {\n      @content;\n    }\n  }@else if $breakpoint == 'large' {\n    @media (min-width: 1025px) {\n      @content;\n    }\n  }\n}\n\n@mixin vendor-prefix($name, $value) {\n  @each $vendor in ('-webkit-', '-moz-', '-ms-', '-o-', '') {\n    #{$name}: #{$value};\n  }\n}\n\n\n@mixin placeholder() {\n  color: color(inverse, light) !important;\n  font-family: 'Omnes-ATT-W02-Italic'!important;\n  font-style: normal;\n  opacity: 1;\n  font-size: 16px;\n}\n\n// dynamic\n@include respond-to(small) {\n  @each $gridname, $gridvalue in $grids {\n    .col-sm-#{$gridname} {\n      width: $gridvalue;\n    }\n  }\n  @each $gridname, $gridvalue in $grids {\n    .col-sm-offset-#{$gridname} {\n      margin-left: $gridvalue;\n    }\n  }\n}\n@include respond-to (large) {\n  @each $gridname, $gridvalue in $grids {\n    .col-md-#{$gridname} {\n      width: $gridvalue;\n    }\n  }\n  @each $gridname, $gridvalue in $grids {\n    .col-md-offset-#{$gridname} {\n      margin-left: $gridvalue;\n    }\n  }\n}\n","// Global Variables\n@import './../../../../../assets/style/var-config';\n// grids here\n$grids: (\n  1: 8.33%,\n  2: 16.66%,\n  3: 25%,\n  4: 33.33%,\n  5: 41.66%,\n  6: 50%,\n  7: 58.33%,\n  8: 66.66%,\n  9: 75%,\n  10: 83.33%,\n  11: 91.66%,\n  12: 100%\n);\n\n\n// refer http://digitaldesign.web.att.com/getstarted-color.html\n$att-dark-blue: hsl(205, 94%, 35%); // #0568ae\n$f-red: hsl(0, 66%, 49%); // #cf2a2a Functional Red\n$fb-gray: hsl(0, 0%, 95%); // #f2f2f2 Functional background Gray\n$att-dark-gray: hsl(0, 0%, 35%); // #5a5a5a\n$f-green: hsl(150, 100%, 24%); // #007a3e functional Green\n// $att-orange: hsl(30, 100%, 46%); // #ea7400 ATT Orange\n$att-orange: #ea7400; //ATT Orange\n\n// set color map easy use variables\n$primary: $att-orange !default;\n$secondary: $att-dark-blue !default;\n$default: $fb-gray !default;\n$inverse: $att-dark-gray !default;\n$danger: $f-red !default;\n$success: $f-green !default;\n\n\n// color variable map\n$colors: (\n  info: #009fdb,\n  enrolledActive:  #66cc00,\n  enrolledNotActive: #70c5e9,\n  notEnrolled: #fdb91d,\n  outOfCompliance: #cccccc,\n  appleNotinstalled: #fcbb15, \n\n  // Primary - Blue color\n  primary: (\n    base: $primary,\n    light: lighten($primary, 15%),\n    lightest: lighten($primary, 60%),\n    dark: darken($primary, 15%)\n  ),\n\n  // Secondary - Orange color\n  secondary: (\n    base: $secondary,\n    light: lighten($secondary, 15%),\n    lightest: lighten($secondary, 60%),\n    dark: darken($secondary, 15%)\n  ),\n\n  // default - Gray color\n  default: (\n    base: $default,\n    light: lighten($default, 5%), // #fff white\n    dark: darken($default, 12.8%), // #d2d2d2 ATT Light Gray\n    darker: darken($default, 18%) // #c4c4c4\n  ),\n\n  // Inverse - Black color\n  inverse: (\n    base: $inverse,\n    light: lighten($inverse, 11.25%), // #767676 Auxiliary Gray\n    lightest: lighten($inverse, 25%), // #999999\n    lighter: lighten($inverse, 23.4%), // #959595 ATT Gray\n    dark: darken($inverse, 15%), // #333 ATT Dark Gray (2015)\n    darker: darken($inverse, 25.2%), // #191919 Functional Digital Text Black\n    darkest: darken($inverse, 35%) // #000 \n  ),\n\n  // danger - Red color\n  danger: (\n    base: $danger,\n    light: lighten($danger, 15%),\n    dark: darken($danger, 15%)\n  ),\n\n  // success - Green color\n  success: (\n    base: $success,\n    light: lighten($success, 15%),\n    dark: darken($success, 15%)\n  )\n);\n","@import '../../assets/style/mixinfunction';\n\n.tab-section {\n  [class*='icon-accordion-'] {\n    @include respond-to(small) {\n      display: inline-block !important;\n      float: right;\n      margin-top: -10px;\n      position: absolute;\n      right: 10px;\n      top: 50%;\n    }\n    display: none !important;\n  }\n}\n\n.tab-nav {\n  border-bottom: 1px solid color(default, dark);\n\n  app-tab {\n    @include respond-to(small) {\n      float: none;\n\n      .list > a {\n        border-left: 0 !important;\n        border-right: 0 !important;\n        border-top: 0 !important;\n        padding: 25px 15px !important;\n        position: relative;\n\n        &:focus {\n          outline: 0;\n        }\n      }\n\n      &:first-child {\n        .list > a {\n          border-top: 1px solid color(default, dark) !important;\n        }\n      }\n\n      &:last-child {\n        & + .tab-content {\n          border-bottom: 0;\n        }\n      }\n\n      &.active {\n        & + .tab-content {\n          border-bottom: 1px solid color(default, dark);\n\n        }\n\n        &:last-child {\n          .list > a {\n            border-bottom: 0;\n          }\n        }\n      }\n    }\n    float: left;\n\n    .list {\n      &.active > a {\n        border-bottom: 1px solid color(default, light);\n        border-top: 5px solid color(secondary, base);\n        color: color(inverse, darker);\n        padding-top: 25px;\n        }\n\n      a {\n        background: color(default, light);\n        border-bottom: 1px solid color(default, dark);\n        border-right: 1px solid color(default, dark);\n        // border-top: 5px solid transparent;\n        bottom: -1px;\n        color: color(secondary, base);\n        display: block;\n        font-size: 20px;\n        height: 70px;\n        outline: none;\n        padding: 30px 20px 25px;\n        position: relative;\n\n        &:focus {\n          outline: thin dotted color(inverse, darker);\n          outline-offset: 0;\n        }\n      }\n  }\n\n    &:first-of-type {\n      .list {\n        a {\n          border-left: 1px solid transparent;\n        }\n\n        &.active {\n          a {\n            border-left: 1px solid color(default, dark);\n            }\n          }\n        }\n      }\n\n    &:last-of-type {\n      .list {\n        a {\n          border-right: 1px solid transparent;\n          }\n\n        &.active {\n          a {\n            border-right: 1px solid color(default, dark);\n            }\n          }\n        }\n      }\n  }\n}\n\n.tab-content {\n  @include respond-to(small) {\n    border-bottom: 1px solid color(default, dark);\n    padding-top: 0;\n    position: relative;\n    top: 1px;\n\n    h2 {\n      margin-bottom: 0 !important;\n      margin-top: 20px !important;\n    }\n\n    p {\n      margin-bottom: 5px !important;\n    }\n  }\n  left: 0;\n  padding: 15px;\n  position: absolute;\n  top: 70px;\n  width: 100%;\n\n  h2 {\n    font-size: 1.9rem;\n    font-weight: bold;\n    margin-bottom: 20px;\n    margin-top: 40px;\n  }\n\n  ul {\n    margin: 0 0 20px 20px;\n\n    li {\n      line-height: 20px;\n      margin-top: 12px;\n      padding-left: 15px;\n      position: relative;\n      text-align: left;\n\n      &:first-child{\n        margin-top: 5px;\n      }\n\n      &::after {\n        background-color: color(inverse, dark);\n        border: 2px solid color(inverse, dark);\n        border-radius: 100%;\n        content: '';\n        display: block;\n        height: 1px;\n        left: 0;\n        position: absolute;\n        top: 8px;\n        width: 1px;\n      }\n    }\n  }\n\n  h4 {\n    font-family: 'Omnes-ATT-W02-Medium';\n    font-size: 1.6rem;\n    margin: 10px 0 5px;\n  }\n\n  p {\n    margin-bottom: 15px;\n  }\n\n  .price-box {\n    @include respond-to (x-small) {\n      margin: 10px 0 20px;\n      text-align: center;\n\n      .btn {\n        margin: 15px 0 0;\n        width: 100%;\n\n      }\n    }\n    @include vendor-prefix('border-radius', 8px);\n    border: 1px solid color(default, dark);\n    margin: 10px -15px 20px;\n    padding: 15px;\n\n    .price {\n      display: inline-block;\n      font-size: 3rem;\n      margin-bottom: 10px;\n      margin-right: 10px;\n    }\n\n    p {\n      margin-bottom: 0;\n    }\n  }\n}\n\n// this css if for dynamic content that is appended\n.gray-box {\n  background: color(default, base);\n  margin-top: 20px;\n  padding: 15px;\n}\n\n\n"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
